export default {
  maintenance_title:
    'Acuity Insights est présentement hors service pour une maintenance informatique planifiée.',
  maintenance_message:
    'Nous serons de retour sous peu. Merci de votre patience.'
};
